import { FC } from 'react'
import { Circle } from 'react-leaflet'

import { ShapeType } from '@kouto/types'
import { useDraggableShape } from 'hooks'
import { MapShapeProps } from './Shape'

export const DraggableCircle: FC<MapShapeProps> = ({
  canDragOutsideMap,
  mapSize,
  currentMapScale,
  ...shape
}) => {
  const { bounds, shapeRef } = useDraggableShape<ShapeType.CIRCLE>(
    shape,
    canDragOutsideMap,
    mapSize,
  )

  const scaledRadius =
    Math.round((shape.width / 2 / currentMapScale) * 1000) / 1000

  return (
    <Circle
      key={`${shape.id}-${shape.color}`}
      ref={shapeRef}
      radius={scaledRadius}
      center={bounds.getCenter()}
      color="#FFFFFF"
      opacity={1}
      fillOpacity={1}
      fillColor={shape.color}
      className={shape.className}
    >
      {shape.children}
    </Circle>
  )
}
